"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.ProductGenericInfo = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _ProductInfoItem = require("./ProductInfoItem");

var _Core = require("../../components/Core");

var _class;

var ProductGenericInfo = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ProductGenericInfo, _Component);

  function ProductGenericInfo(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ProductGenericInfo.prototype;

  _proto.render = function render() {
    var productDetail = this.props.productDetail;
    return _react.default.createElement(_Core.Box, {
      w: 1
    }, _react.default.createElement(_Core.Flex, {
      flexWrap: "wrap"
    }, _react.default.createElement(_ProductInfoItem.ProductInfoItem, {
      label: "Manufacturer",
      info: productDetail.manufacturer
    }), _react.default.createElement(_ProductInfoItem.ProductInfoItem, {
      label: "Brand",
      info: productDetail.brand
    })));
  };

  return ProductGenericInfo;
}(_react.Component)) || _class;

exports.ProductGenericInfo = ProductGenericInfo;